import { useEffect, useRef } from "react";

const EarnedAccreditationRepeater = ({ user_field_name = 'earning_accred_user', date_field_name = 'earning_accred_date' }) => {

  const tangibleFields = window.tangibleFields
  const { ajax } = window.Tangible

  const fetching = useRef(false)
  const fetchAgain = useRef(false)

  useEffect(() => {
    setTimeout(() => {
      tangibleFields.store.setValue('earning_accreds', [])
    }, 0 )
  }, [])

  const getAccreditationData = ( user_id, date ) => {
    if ( fetching.current ) {
      fetchAgain.current = true
      return
    }
    fetching.current = true

    ajax('tgbl_cred_get_possible_earned_accreditations', { user_id: user_id, date: date })
      .then( result => {
        const result_json = JSON.parse(result)
        let accreditation_list = []

        if ( result_json.length > 0 ) {
          for ( let accred of result_json ) {

            let content_choices = {};
            for(const criteria of accred.issuance_criteria) {
              content_choices[criteria.content_id] = `${criteria.content_name}: ${criteria.completion_blurb}`;
            }

            accreditation_list.push({
              accreditation_id: accred.accreditation_id,
              accreditation_name: accred.accreditation_name,
              content: {
                choices: content_choices,
                value: Object.keys(content_choices)[0]
              }
            })
          }
        }
        tangibleFields.store.setValue('earning_accreds', accreditation_list)

        fetching.current = false
        // Run it back if there was a previous request
        if ( fetchAgain.current ) {
          fetchAgain.current = false
          getAccreditationData(
            tangibleFields.store.getValue('earning_accred_user')['value'],
            tangibleFields.store.getValue('earning_accred_date')
          )
        }
      })
      .catch( error => { console.error(error) })
  }

  tangibleFields.event('valueChange', field => {
    if ( field.name === user_field_name || field.name === date_field_name ) {
      setTimeout(() => {
        let user_id = tangibleFields.store.getValue(user_field_name)['value']
        let date = tangibleFields.store.getValue(date_field_name)
        if ( user_id === undefined || typeof date === 'object' ) return

        getAccreditationData( user_id, date )
      }, 0)
    }
  })

  const accreditations = tangibleFields.render({
    type: 'repeater',
    name: 'earning_accreds',
    layout: 'table',
    label: 'Accreditations',
    description: 'Select the accreditation earned by the selected user(s). Only those associated with accrediting agencies the user is enrolled to will appear.',
    fields: [
      { type: 'hidden', name: "accreditation_id" },
      { label: "Accreditation", type: 'text', name: "accreditation_name" },
      { label: "Related Content", type: 'repeaterSelect', name: "content" }
    ]
  })

  return (
    <div className="tgbl-earned-accreditation-repeater">
      { accreditations }
    </div>
  )
}

export { EarnedAccreditationRepeater }

